<template>
    <div class="topbar"> 
        <img :src="config.logo" alt="care" class="topbar__logo"/>
        <div class="topbar__language" v-if="availableLanguages.length > 0">
            <select v-if="config.translate && targetLanguage !== null" v-model="targetLanguage" @change="selectLanguage">
                <option v-for="language in availableLanguages" :key="availableLanguages.indexOf(language)" :value="language">{{language.emoji}} {{language.name}}</option>
            </select>
        </div>
    </div> 
</template>

<script>
import languages from '../lib/languages'
import { config } from '../constants.js';

export default {
    name: 'TopBar',
    data() {
        return {
            availableLanguages: languages,
            targetLanguage: languages[0],
            config
        }
    },
    methods: {
        selectLanguage() {
            this.$emit('translationRequested', this.targetLanguage)
        }
    },
    watch:{
        targetLanguage: function(newVal, oldVal) {
            this.$emit('storePreviousLanguage', oldVal)
        }
    }   
}
</script>

<style>
    .topbar {
        background-color: var(--headerBgColor);
        color: #eee;
        height: 65px;
        width: 100%;
    }
    h1 {
        text-align: center;
    }
    .topbar__language {
        position: absolute;
        top: 15px;
        right: 40px;
        text-align: right;
        width: 50%;
    }

    .topbar__language select {
        min-height: 25px;
        padding: 5px;
    }

    .topbar__logo {
        margin: 10px;
        max-height: 75%;
        max-width: 30%;
    }
</style>